/* The two-reader scripts, collapsed (2026-09-23, Dana's ask).

   Articles from the writing pipeline carry the scripts in their own body markup:
     <div class="scripts"><div class="box"><h3>What to tell your kid</h3><p>"…"</p></div>…</div>
   so this is done here rather than in Liquid. The article content is never edited: the real
   heading is MOVED into the summary (it stays a heading for a screen reader) and the rest of
   the box becomes the panel.

   Progressive enhancement. Script off, or this file blocked, and both scripts are printed in
   full exactly as before. The text stays in the DOM either way, so it is still indexed and
   still reachable by find-in-page in browsers that search inside a closed <details>.

   A duty-of-care File never loads this: on those everything is printed in full. */
(function () {
  'use strict';
  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }
  function collapse(box) {
    if (box.dataset.lfScript) return;
    var head = box.querySelector('h2, h3, h4');
    if (!head) return;                      /* no title to tap, leave it printed */
    box.dataset.lfScript = '1';
    var d = el('details', 'lf-script-drop'),
        sum = el('summary', 'lf-script-drop__sum'),
        chev = el('span', 'lf-script-drop__chev'),
        body = el('div', 'lf-script-drop__body');
    chev.setAttribute('aria-hidden', 'true');
    sum.appendChild(head);                  /* the real heading, moved not copied */
    sum.appendChild(chev);
    while (box.firstChild) body.appendChild(box.firstChild);
    d.appendChild(sum); d.appendChild(body);
    box.appendChild(d);
  }
  /* the pipeline does not use one class for the boxes: .box on some Files, .script .kid /
     .script .par on others. Any element child of .scripts that carries a heading is a script. */
  function scan() {
    document.querySelectorAll('.lf-fbody__prose .scripts').forEach(function (wrap) {
      Array.prototype.forEach.call(wrap.children, collapse);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();